export const HERO_TRANSITION = {
  ease: "easeIn",
  duration: 1,
  flip: "Infinity",
  repeatDelay: 4,
  delay: 4,
};
export const ANIMATE_OPACITY = {
  opacity: [0, 1],
};
export const ANIMATE_HERO_HEADER = {
  ...ANIMATE_OPACITY,
  zIndex: 1,
};
export const ANIMATE_HERO_HEADER_REVERSE = {
  opacity: [1, 0],
  zIndex: 1,
};
export const ANIMATE_OPACITY_OUT = {
  opacity: [1, 0],
};

export const TOPBAR_TRANSITION = { duration: 0.4 };
export const TOPBAR_ANIMATE = { y: [-64, 0] };

export const EASE_IN_TRANSITION = { transition: "easeIn", duration: 0.6 };
export const SIGNUP_SECTION_ANIMATE = { y: [30, 0], opacity: [0, 1] };

export const CATEGORIES_GROUP_ANIMATE = { y: [20, 0], opacity: [0, 1] };

export const CATEGORIES_SECTION_ANIMATE = { y: [100, 0], opacity: [0, 1] };

export const SLIDE_UP_TRANSITION = { ...EASE_IN_TRANSITION, delay: 0.2 };
export const SLIDE_UP_ANIMATE = { y: [50, 0], opacity: [0, 1] };

export const DROPDOWN_ANIMATE = { y: [-200, 0], opacity: [0, 1] };

export const ANIMATE_JOB_REQUEST_HEADER_IN = { top: [-106, 0], left: 0, right: 0, margin: "0 auto" };
export const ANIMATE_JOB_REQUEST_HEADER_OUT = { top: [0, -106] };

export const SHOW_MORE_TRANSITION = { ...EASE_IN_TRANSITION, delay: 1.2 };
export const COOKIES_INFO_ANIMATE = { y: [88, 0] };
